export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password and try again.',
  patientIndexSuccess: 'You can search for one.',
  patientIndexFailure: 'Do you have patients?',
  patientCreateSuccess: 'Patient is in the system.',
  patientCreateFailure: 'Patient is not in the system.',
  patientShowSuccess: 'Here is the patient\'s info.',
  patientShowFailure: 'Could not show patient\'s info.',
  patientDeleteSuccess: 'Patient has been removed from the system.',
  patientDeleteFailure: 'Patient is still in the system.',
  patientEditSuccess: 'Patient info has been updated.',
  patientEditFailure: 'Patient is still the same.'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js